import i18n from "i18next";
import baremetal from "assets/images/environments/baremetal.png";
import azure from "assets/images/environments/azure.png";
import aws from "assets/images/environments/aws.png";
import google_cloud from "assets/images/environments/google_cloud.png";
import vmware from "assets/images/environments/vmware.png";
import small_vm from "assets/images/environments/small_vm.png";
import small_aws from "assets/images/environments/small_aws.png";
import small_azure from "assets/images/environments/small_azure.png";
import small_google from "assets/images/environments/small_google.png";

import OS_ICON from "assets/icons/os_layer.svg";
import K8S_ICON from "assets/icons/k8s_layer.svg";
import CNI_ICON from "assets/icons/cni_layer.svg";
import CSI_ICON from "assets/icons/csi_layer.svg";
import LOAD_BALANCER_ICON from "assets/icons/load_balancer_layer.svg";
import SECURITY_ICON from "assets/icons/security_layer.svg";
import LOGGING_ICON from "assets/icons/logging_layer.svg";
import INGRESS_ICON from "assets/icons/ingress_layer.svg";
import MONITORING_ICON from "assets/icons/monitoring_layer.svg";
import AUTHENTICATION_ICON from "assets/icons/authentication_layer.svg";
import SYSTEM_APP_ICON from "assets/icons/system_app_layer.svg";
import SERVICE_MESH_ICON from "assets/icons/service_mesh_layer.svg";
import REGISTRY_ICON from "assets/icons/registry_layer.svg";

import {
  cyan,
  yellow,
  green,
  marine,
  concrete,
  darkOrange,
} from "utils/constants/colors";
import flags from "services/flags";

export const AWS_ENVIRONMENT = {
  logoPath: aws,
  name: "Amazon AWS",
  apiKey: "aws",
  smallLogoPath: small_aws,
};

export const BAREMETAL_ENVIRONMENT = {
  logoPath: baremetal,
  name: "Bare Metal",
  apiKey: "baremetal",
};

export const AZURE_ENVIRONMENT = {
  logoPath: azure,
  name: "Azure",
  apiKey: "azure",
  smallLogoPath: small_azure,
  disabled: !flags.has("azure"),
};

export const GOOGLE_CLOUD_ENVIRONMENT = {
  logoPath: google_cloud,
  name: "Google Cloud",
  apiKey: "gcp",
  smallLogoPath: small_google,
  disabled: !flags.has("gcp"),
};

export const VMWARE_ENVIRONMENT = {
  logoPath: vmware,
  name: "VMware",
  apiKey: "vsphere",
  smallLogoPath: small_vm,
};

export const ENVIRONMENTS = [
  //TODO: update baremetal env when it'll be used
  // BAREMETAL_ENVIRONMENT,
  AWS_ENVIRONMENT,
  VMWARE_ENVIRONMENT,
  AZURE_ENVIRONMENT,
  GOOGLE_CLOUD_ENVIRONMENT,
];

const CSI_LAYER = {
  type: "csi",
  title: () => i18n.t("Storage"),
  color: cyan,
  icon: CSI_ICON,
};
const CNI_LAYER = {
  type: "cni",
  title: () => i18n.t("Network"),
  color: yellow,
  icon: CNI_ICON,
};
export const KUBERNETES_LAYER = {
  type: "k8s",
  title: () => i18n.t("Kubernetes"),
  color: concrete,
  icon: K8S_ICON,
};
const OS_LAYER = {
  type: "os",
  title: () => i18n.t("OS"),
  color: darkOrange,
  icon: OS_ICON,
};

const LOAD_BALANCER_LAYER = {
  type: "load balancer",
  title: () => i18n.t("Load balancer"),
  color: yellow,
  isDeletable: true,
  icon: LOAD_BALANCER_ICON,
};
export const INGRESS_LAYER = {
  type: "ingress",
  title: () => i18n.t("Ingress"),
  color: yellow,
  isDeletable: true,
  icon: INGRESS_ICON,
};
const LOGGING_LAYER = {
  type: "logging",
  title: () => i18n.t("Logging"),
  color: green,
  isDeletable: true,
  icon: LOGGING_ICON,
};
const MONITORING_LAYER = {
  type: "monitoring",
  title: () => i18n.t("Monitoring"),
  color: green,
  isDeletable: true,
  icon: MONITORING_ICON,
};
const SECURITY_LAYER = {
  type: "security",
  title: () => i18n.t("Security"),
  color: marine,
  isDeletable: true,
  icon: SECURITY_ICON,
};
const AUTHENTICATION_LAYER = {
  type: "authentication",
  title: () => i18n.t("Authentication"),
  color: marine,
  isDeletable: true,
  icon: AUTHENTICATION_ICON,
};
const SYSTEM_LAYER = {
  type: "system app",
  title: () => i18n.t("System App"),
  color: darkOrange,
  isDeletable: true,
  icon: SYSTEM_APP_ICON,
};

const SERVICE_MESH_LAYER = {
  type: "servicemesh",
  title: () => i18n.t("Service Mesh"),
  color: cyan,
  isDeletable: true,
  icon: SERVICE_MESH_ICON,
};

const REGISTRY_LAYER = {
  type: "registry",
  title: () => i18n.t("Registry"),
  color: cyan,
  isDeletable: true,
  icon: REGISTRY_ICON,
};

export const LAYERS = [
  OS_LAYER,
  CSI_LAYER,
  CNI_LAYER,
  KUBERNETES_LAYER,
  LOAD_BALANCER_LAYER,
  INGRESS_LAYER,
  LOGGING_LAYER,
  MONITORING_LAYER,
  SECURITY_LAYER,
  AUTHENTICATION_LAYER,
  SERVICE_MESH_LAYER,
  SYSTEM_LAYER,
  REGISTRY_LAYER,
];

export const SPECTRO_TAG = "spectro__tag";

export const ENV_COLORS = {
  aws: "#ff9900",
  vsphere: "#717075",
};

export const PASSWORD_UPDATE_POLICY = [
  {
    label: "3 months",
    value: 90,
  },
  { label: "6 months", value: 183 },
  { label: "Custom", value: "Custom" },
];

export const UPDATE_STRATEGIES = [
  {
    label: "Expand First",
    value: "RollingUpdateScaleOut",
  },
  {
    label: "Contract First",
    value: "RollingUpdateScaleIn",
  },
];
